import React from "react";
import { ReactSVG } from "react-svg";
import Path from "react-svg-path";

const LogoSmall = (props) => {
  return (
    <svg
      width="34"
      height="10"
      viewBox="0 0 34 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.136 10L9.122 4.134L6.238 8.964H5.23L2.346 4.246V10H0.218V0.199999H2.094L5.762 6.29L9.374 0.199999H11.25L11.264 10H9.136ZM20.3345 7.9H15.7845L14.9165 10H12.5925L16.9605 0.199999H19.2005L23.5825 10H21.2025L20.3345 7.9ZM19.6205 6.178L18.0665 2.426L16.5125 6.178H19.6205ZM28.6761 6.052H27.1081V10H24.8541V0.199999H27.1081V4.162H28.7321L31.3081 0.199999H33.7021L30.4961 4.932L33.8001 10H31.2241L28.6761 6.052Z"
        fill="white"
      />
    </svg>
  );
};

export default LogoSmall;
